import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ReportItemsPageInterface } from '@zaoblako/shared/common/dtos/report/report-items-page.dto';
import type { PassageOrderFindManyQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-order/passage-order-find-many-query.dto';
import type { PassageOrderFindInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-order/passage-order-find.dto';
import type { PassageOrderPageInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-order/passage-order-page.dto';
import { PassageOrderStatusEnum } from '@zaoblako/shared/modules/pacs/enums/passage-order-status.enum';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PassageOrderService extends BaseService {
  protected baseUrl = '/pacs/base/passage-order';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public findRegistryPage(
    query?: PassageOrderFindManyQueryInterface
  ): Observable<ReportItemsPageInterface<PassageOrderFindInterface>> {
    return this.http.get<ReportItemsPageInterface<PassageOrderFindInterface>>(`${this.baseUrl}/items`, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }

  public findMany(query?: PassageOrderFindManyQueryInterface): Observable<PassageOrderPageInterface> {
    return this.http.get<PassageOrderPageInterface>(`${this.baseUrl}/items`, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }

  public switchStatus(id: number, status: PassageOrderStatusEnum): Observable<PassageOrderFindInterface> {
    return this.http.post<PassageOrderFindInterface>(`${this.baseUrl}/${id}/switch-status`, { status });
  }

  public restoreOne(id: number): Observable<PassageOrderFindInterface> {
    return this.http.post<PassageOrderFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, query?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }
}
